<template>
  <div :id="particleId"></div>
</template>

<script>
import { tsParticles } from '@tsparticles/engine'
import { loadBasic } from '@tsparticles/basic'

// UiButton 会在字段引导粒子抵达时立即显示光效；模块加载时提前准备引擎，
// 避免第一次抵达后再初始化造成肉眼可见的滞后。
const engineReady = loadBasic(tsParticles)

function ensureEngine () {
  return engineReady
}

export default {
  name: 'FireParticleAura',
  props: {
    particleId: { type: String, required: true },
    options: { type: Object, required: true },
    anchor: { type: HTMLElement, default: null }
  },
  data () {
    return { container: null, destroyed: false, resizeObserver: null }
  },
  async mounted () {
    // 粒子浮层提升到 body，避免被卡片、标题栏和滚动容器的 overflow 裁切。
    document.body.appendChild(this.$el)
    this.updatePosition()
    window.addEventListener('resize', this.updatePosition)
    window.addEventListener('scroll', this.updatePosition, true)
    if (window.ResizeObserver && this.anchor) {
      this.resizeObserver = new window.ResizeObserver(this.updatePosition)
      this.resizeObserver.observe(this.anchor)
    }
    await ensureEngine()
    if (this.destroyed) return
    this.container = await tsParticles.load({ id: this.particleId, options: this.options })
  },
  beforeDestroy () {
    this.destroyed = true
    window.removeEventListener('resize', this.updatePosition)
    window.removeEventListener('scroll', this.updatePosition, true)
    if (this.resizeObserver) this.resizeObserver.disconnect()
    if (this.container) this.container.destroy()
  },
  methods: {
    updatePosition () {
      if (!this.anchor || !this.anchor.isConnected) return
      const rect = this.anchor.getBoundingClientRect()
      Object.assign(this.$el.style, {
        left: `${rect.left - 24}px`,
        top: `${rect.top - 30}px`,
        width: `${rect.width + 48}px`,
        height: `${rect.height + 40}px`
      })
    }
  }
}
</script>
